import { post } from '@js/common/api'
import { supportsLocalStorage } from '@js/common/utils'

/**
 * All the authentication code was left because of Planoa. The Fertighaus code
 * was moved into UA.ts
 * As for the other functions, there needs to be a decission to keep the
 * functionality or remove it, as we're now relying more on server data for the
 * user, instead of basing everything on localStorage, like we used to
 */
const User = {
  authenticate(token, expires) {
    localStorage.setItem('AuthToken', token)
    localStorage.setItem('AuthTokenExpires', expires)
  },

  isAuthenticated() {
    if (!supportsLocalStorage()) {
      return false
    }
    const authToken = localStorage.getItem('AuthToken')
    const authTokenExpires = localStorage.getItem('AuthTokenExpires')

    // If there's no auth token, the user is not authenticated.
    if (authToken === null) {
      return false
    }
    // Else check the expiry date of the token
    if (new Date(Number(authTokenExpires)) > new Date()) {
      return true
    }
    User.deauthenticate()
    return false
  },

  deauthenticate() {
    localStorage.removeItem('AuthToken')
    localStorage.removeItem('last-sync')
    localStorage.removeItem('user')
    localStorage.removeItem('AuthTokenExpires')
  },

  getHouseSearchParams() {
    if (!/fu/.test(window['🍪'].read('cookie_policy_config'))) {
      return {}
    }

    return JSON.parse(localStorage.getItem('search') || '{}').query || {}
  },

  getHouseSearchParam(param, fallback) {
    const params = User.getHouseSearchParams()
    if (params.hasOwnProperty(param)) {
      return params[param]
    }
    return fallback
  },

  storeRequestedVendor(vendorNid) {
    const request = JSON.parse(localStorage.getItem('request') || '{}')
    const requestedVendors = request.requestedVendors || []

    const vendorAlreadyStored = requestedVendors.includes(vendorNid)
    if (vendorAlreadyStored) {
      return
    }

    requestedVendors.push(vendorNid)
    localStorage.setItem(
      'request',
      JSON.stringify({ ...request, requestedVendors })
    )
  },

  getRequestedVendors() {
    return (
      JSON.parse(localStorage.getItem('request') || '{}').requestedVendors || []
    )
  },

  storeUserDetails(data) {
    if (data.hasOwnProperty('vendor')) {
      User.storeRequestedVendor(data.vendor)
    }

    if (
      data.hasOwnProperty('selected_vendors') &&
      data.hasOwnProperty('selected_target') &&
      data.selected_target === 'vendor'
    ) {
      data.selected_vendors
        .split(',')
        .map(id => parseInt(id))
        .forEach(id => User.storeRequestedVendor(id))
    }

    const whitelist = [
      'gender',
      'first_name',
      'last_name',
      'street',
      'postal_code',
      'city',
      'country',
      'phone',
      'phone_country_prefix',
      'uuid'
    ]

    if (User.isAuthenticated()) {
      whitelist.push('property', 'construction_start')
    }

    let formData = {}
    Object.keys(data)
      .filter(k => whitelist.indexOf(k) > -1)
      .forEach(k => (formData[k] = data[k]))

    if (User.isAuthenticated()) {
      // Needs refactoring: Update user account data
    } else {
      const request = JSON.parse(localStorage.getItem('request') || '{}')
      localStorage.setItem('request', JSON.stringify({ ...request, formData }))
    }
  },

  setLocation(location = {}) {
    const currentUserData = JSON.parse(localStorage.getItem('user') || '{}')

    const updatedUserData = {
      ...currentUserData,
      project: {
        ...currentUserData.project,
        delivery_region: location
      }
    }

    localStorage.setItem('user', JSON.stringify(updatedUserData))

    if (location.postcode && User.isAuthenticated()) {
      post('profile', {
        delivery_region: JSON.stringify(location)
      })
    }

    return location
  },

  getLocation() {
    const userData = JSON.parse(localStorage.getItem('user') || '{}')

    return /^(DE|AT)-/.test(userData.project?.delivery_region?.postcode)
      ? userData.project.delivery_region
      : {}
  }
}

export default User
